export const INACTIVE = 'inactive';
export const SUBMIT = 'Submit';
export const COMMENT = 'comment';
export const LOST = 'lost';
export const APPROVE = 'Approve';